export type StepState = 'completed' | 'running' | 'not-started'

export const getStepState = (progress: number): StepState => {
  if (progress === 100) return 'completed'
  if (progress === 50) return 'running'
  return 'not-started'
}
